import axios from "axios";
import { jwtDecode } from "jwt-decode";

export interface DecodedToken {
  c_org_id?: string;
  c_user_id?: string;
  [key: string]: any;
}

export function route(
  endpoint: string,
  params: Record<string, string> = {},
  query: Record<string, string> = {},
): string {
  const url = Object.entries(params).reduce((acc, [key, value]) => {
    const paramRegex = new RegExp(`:${key}`, "g");
    return acc.replace(paramRegex, value);
  }, endpoint);

  if (Object.keys(query).length > 0) {
    const queryString = new URLSearchParams(query).toString();
    return `${url}?${queryString}`;
  }

  return url;
}

export function getOrgIdFromToken(token?: string): string {
  if (!token) {
    throw new Error("Token is required to extract organization ID");
  }

  const decodedToken = jwtDecode(token) as DecodedToken;

  if (decodedToken.c_org_id) {
    return decodedToken.c_org_id;
  }

  throw new Error("Could not find organization ID in token");
}

export function getUserIdFromToken(token?: string): string {
  if (!token) {
    throw new Error("Token is required to extract user ID");
  }

  const decodedToken = jwtDecode(token) as DecodedToken;

  if (decodedToken.c_user_id) {
    return decodedToken.c_user_id;
  }

  throw new Error("Could not find user ID in token");
}

export function handleAxiosError(e: Error | unknown): never {
  if (axios.isAxiosError(e) && e.response && e.response.data.error?.message) {
    const message =
      errorMessages[e.response.data.error.message] ||
      e.response.data.error.message;
    throw new Error(message);
  } else {
    throw new Error("An unexpected error occurred");
  }
}

const errorMessages: Record<string, string> = {
  // Add more error message mappings as needed
};
